import React from 'react'
import AttendanceSubNav from '../components/AttendanceSubNav'
import DailyAttendanceDateNav from './components/DailyAttendanceDateNav'
import DailyAttendanceMetrics from './components/DailyAttendanceMetrics'
import DailyAttendanceTable from './components/DailyAttendanceTable'
import SharedFilters from '../../../components/SharedFilters'
import PredefinedReportsDrawer from '../../../components/PredefinedReportsDrawer'
import AttendanceBottomBar from '../components/AttendanceBottomBar'
import useDailyAttendance from './hooks/useDailyAttendance'

export default function DailyAttendanceScreen() {
  const { state, actions } = useDailyAttendance()

  const toolsConfig = [
    { key: 'print-report', label: 'Print Report', icon: 'print' },
    { key: 'send-sms', label: 'Send SMS Alerts', icon: 'sms' },
    { key: 'send-whatsapp', label: 'Send WhatsApp Alerts', icon: 'chat' },
    { key: 'read-swipes', label: 'Read Biometric Swipes', icon: 'fingerprint' },
    { key: 'read-lectures', label: 'Read From Scheduled Lectures', icon: 'school' },
  ]

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-24">
      {/* ── Top Canopy: Header & SubNav ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">Attendance Tracking</p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Daily Student Attendance
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Mark daily attendance, reconcile biometric swipes, and broadcast absent notifications.
          </p>
        </div>

        {/* ── Date Navigator Bar ── */}
        <DailyAttendanceDateNav
          date={state.date}
          onDateChange={actions.setDate}
          onPrevDate={actions.handlePrevDate}
          onNextDate={actions.handleNextDate}
          onToday={actions.handleToday}
          onYesterday={actions.handleYesterday}
        />
      </section>



      {/* ── KPI Summary Metrics Bar ── */}
      {/* <DailyAttendanceMetrics metrics={state.metrics} loading={state.loading} /> */}

      {/* ── Shared Filter Accordion & Tools ── */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        companyFilter={state.companyFilter}
        branchFilter={state.branchFilter}
        courseFilter={state.courseFilter}
        schoolFilter={state.schoolFilter}
        academicYearFilter={state.academicYearFilter}
        batchFilter={state.batchFilter}
        subjectFilter={state.subjectFilter}
        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setCompanyFilter={actions.setCompanyFilter}
        setBranchFilter={actions.setBranchFilter}
        setCourseFilter={actions.setCourseFilter}
        setSchoolFilter={actions.setSchoolFilter}
        setAcademicYearFilter={actions.setAcademicYearFilter}
        setBatchFilter={actions.setBatchFilter}
        setSubjectFilter={actions.setSubjectFilter}
        onReset={actions.handleResetFilters}
        onSearch={() => { }}
        searchFieldOptions={state.options.searchFields}
        companyOptions={state.options.companies}
        branchOptions={state.options.branches}
        courseOptions={state.options.courses}
        schoolOptions={state.options.schools}
        batchOptions={state.options.batches}
        subjectOptions={state.options.subjects}
        academicYearOptions={state.options.academicYears}
        visibleAccordionFilters={[
          'company',
          'branch',
          'course',
          'school',
          'academicYear',
          'batch',
          'subject',
        ]}
        tools={toolsConfig}
        onToolSelect={(key) => {
          if (key === 'print-report') {
            actions.setIsReportsOpen(true)
          } else if (key === 'send-sms') {
            actions.handleSendSMS()
          } else if (key === 'send-whatsapp') {
            actions.handleSendWhatsApp()
          } else if (key === 'read-swipes') {
            actions.handleReadSwipes()
          } else if (key === 'read-lectures') {
            actions.handleReadFromLectures()
          }
        }}
      />

      {/* ── Daily Attendance Student Grid Table ── */}
      <DailyAttendanceTable
        students={state.students}
        loading={state.loading}
        sortBy={state.sortBy}
        sortOrder={state.sortOrder}
        onSort={actions.handleSort}
        onStatusChange={actions.handleStatusChange}
        onReasonChange={actions.handleReasonChange}
        onMarkAll={actions.handleMarkAll}
      />

      {/* ── Fixed Bottom Save Bar (Shared Component with Sidebar clearance) ── */}
      <AttendanceBottomBar
        totalCount={state.students.length}
        date={state.date}
        presentCount={state.metrics.presentCount}
        presentPct={state.metrics.presentPct}
        absentCount={state.metrics.absentCount}
        absentPct={state.metrics.absentPct}
        holidayCount={state.metrics.holidayCount}
        isSaving={state.isSaving}
        onSave={actions.handleSave}
      />

      {/* ── Predefined Reports Drawer ── */}
      <PredefinedReportsDrawer
        isOpen={state.isReportsOpen}
        onClose={() => actions.setIsReportsOpen(false)}
        title="Daily Attendance Reports"
        module="attendance"
        submodule="daily"
        moduleLabel="Daily Attendance"
        filters={{
          date: state.date,
          academicYear: state.academicYear,
          courseId: state.courseId,
          batchId: state.batchId,
          branchId: state.branchId,
          subjectId: state.subjectId,
          schoolId: state.schoolId,
        }}
      />
    </div>
  )
}
